import { postRequest } from '@/core';
import { trips } from '@/requests';

export default async function getTripsRequest(filter) {
	let url = trips.getSearchPath();
	let response = await postRequest(url, {}, filter);
	return response;
}
